import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Template {
  templateName: string;
  templateUrl: string;
  templateId: string;
  status?: string;
}

interface TemplateState {
  templates: Template[];
  currentTemplateId: string;
  isTemplateStateLoading: boolean;
}

const initialState: TemplateState = {
  templates: [],
  currentTemplateId: '',
  isTemplateStateLoading: false,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplates: (state, action: PayloadAction<Template[]>) => {
      state.templates = action.payload;
    },
    addTemplate: (state, action: PayloadAction<Template>) => {
      if (!state.templates) {
        state.templates = [];
      }
      state.templates.push(action.payload);
    },
    setCurrentTemplateId: (state, action: PayloadAction<string>) => {
      state.currentTemplateId = action.payload;
    },
    setIsTemplateStateLoading: (state, action: PayloadAction<boolean>) => {
      state.isTemplateStateLoading = action.payload;
    },
    clearTemplates: (state) => {
      state.templates = [];
      state.currentTemplateId = '';
    },
  },
});

export const { setTemplates, addTemplate, setCurrentTemplateId, clearTemplates,setIsTemplateStateLoading } = templateSlice.actions;
export default templateSlice.reducer;